import PageHeader from "@/components/PageHeader";
import { Reveal } from "@/components/Reveal";
import { useSeo } from "@/lib/seo";

const SECTIONS = [
  {
    h: "1. Use of this website",
    p: "This website (rific.in) is owned and operated by RIFIC Foods LLP. By using it, you agree to these terms. [Placeholders — to be reviewed by RIFIC's legal team.]",
  },
  {
    h: "2. Content",
    p: "All text, imagery, branding and design on this site belong to RIFIC Foods LLP and may not be copied or reused without permission. Menu items, flavours and store details may vary by location and season.",
  },
  {
    h: "3. Franchise enquiries",
    p: "Submitting a franchise enquiry through this website is an expression of interest only. It does not create any franchise agreement, obligation or right. No statement on this website constitutes an offer, guarantee of returns, or financial projection. All commercial terms are shared only through official RIFIC franchise conversations.",
  },
  {
    h: "4. Accuracy",
    p: "We work to keep this website accurate and current, but details — including store locations, hours and menu — may change without notice.",
  },
  {
    h: "5. Liability",
    p: "To the extent permitted by law, RIFIC is not liable for indirect losses arising from the use of this website.",
  },
  {
    h: "6. Governing law",
    p: "These terms are governed by the laws of India. [Jurisdiction placeholder — to be updated by RIFIC.]",
  },
];

export default function Terms() {
  useSeo({
    title: "Terms | RIFIC",
    description: "Terms of use for rific.in, including franchise enquiry disclaimers.",
    path: "/terms",
  });

  return (
    <div data-testid="terms-page">
      <PageHeader eyebrow="Legal" title={["TERMS OF", "USE."]} />
      <section className="bg-cream pb-16 md:pb-24">
        <div className="mx-auto max-w-3xl px-5 md:px-10">
          {SECTIONS.map((s, i) => (
            <Reveal key={s.h} delay={Math.min(i, 4) * 0.05}>
              <div className="border-t border-cream-line py-8">
                <h2 className="font-display text-xl font-semibold tracking-tight text-deep md:text-2xl">{s.h}</h2>
                <p className="mt-3 font-body text-base leading-relaxed text-deep/70">{s.p}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </section>
    </div>
  );
}
